/**
 * Minimal GDPR/CCPA consent store for ad personalization.
 *
 * This is a lightweight stand-in. Once Ezoic is live, prefer Ezoic's built-in
 * CMP (it handles TCF/consent strings properly) — `ConsentBanner` then just
 * defers to it. Until then, we gate ad requests on this local choice so we never
 * load a personalized ad before the user has chosen.
 *
 * Values: 'granted' | 'denied' | null (undecided).
 */
const KEY = 'ott_ads_consent';
const EVENT = 'ott-ads-consent-changed';

export const getConsent = () => {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(KEY, value);
  } catch {
    /* storage blocked — treat as session-only */
  }
  // Notify live AdSlots so they can request (or stay dark) without a reload.
  window.dispatchEvent(new CustomEvent(EVENT, { detail: value }));
};

export const onConsentChange = (handler) => {
  const wrapped = (e) => handler(e.detail);
  window.addEventListener(EVENT, wrapped);
  return () => window.removeEventListener(EVENT, wrapped);
};

export const CONSENT_EVENT = EVENT;
